'use strict';

var _require = require('../../utils'),
    withTimeoutOption = _require.withTimeoutOption;

module.exports = function (_ref) {
  var keychain = _ref.keychain;
  return withTimeoutOption(function (options) {
    return keychain.listKeys(options);
  });
};